import { render, staticRenderFns } from "./ListSimulations.vue?vue&type=template&id=6a87a1f6&"
import script from "./ListSimulations.vue?vue&type=script&lang=js&"
export * from "./ListSimulations.vue?vue&type=script&lang=js&"
import style0 from "./ListSimulations.vue?vue&type=style&index=0&id=6a87a1f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports